/**
 * Utility functions for link security checking
 */

/**
 * Check if URL is a Zapier domain (zapier.com or zapier-staging.com)
 */
export const isZapierUrl = (url: string): boolean => {
  try {
    const urlObj = new URL(url);
    return /^(.*\.)?zapier(-staging)?\.com$/.test(urlObj.hostname);
  } catch {
    return false;
  }
};

/**
 * Check if URL contains any blocked domains
 */
export const isBlockedUrl = (
  url: string,
  blockedDomains: string[],
): boolean => {
  if (!blockedDomains || blockedDomains.length === 0) {
    return false;
  }

  try {
    const urlObj = new URL(url);
    const hostname = urlObj.hostname.toLowerCase();

    return blockedDomains.some((domain: string) => {
      // Clean the domain config (remove protocol and www)
      const cleanDomain = domain
        .replace(/^https?:\/\//, "")
        .replace(/^www\./, "")
        .toLowerCase();

      // Remove www from hostname for comparison
      const cleanHostname = hostname.replace(/^www\./, "");

      // Check exact match or proper subdomain
      return (
        cleanHostname === cleanDomain ||
        cleanHostname.endsWith(`.${cleanDomain}`)
      );
    });
  } catch {
    return false;
  }
};
